import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { EditIcon, FormController, LinkSize, StyledFlex, Text, TextView } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../../translations';

import { StyledHealthcareProviderLocationTextViewLink } from './HealthcareProviderLocationTextView.styled';

const HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME = 'healthcareProviderLocation';
type HealthcareProviderLocationFormBeanPart = {
   [HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME]: HealthcareProviderLocation | null;
};

type HealthcareProviderLocationTextViewProps = Pick<
   FormContextValues<HealthcareProviderLocationFormBeanPart>,
   'register'
> & {
   readonly editable: boolean;
};

export const HealthcareProviderLocationTextView = (props: HealthcareProviderLocationTextViewProps): JSX.Element => {
   return (
      <FormController<HealthcareProviderLocation> controller={props.register(HEALTHCARE_PROVIDER_LOCATION_FIELD_NAME)}>
         {({ value: healthcareProviderLocation, onBlur }) => (
            <TextView
               label={appointmentsTranslationKeys.create.form.healthcareProviderLocation.label}
               testId={'healthcareProviderLocation'}
            >
               <StyledFlex gap={'8px'}>
                  <Text testId={'name'}>{healthcareProviderLocation.name}</Text>
                  {props.editable ? (
                     <StyledHealthcareProviderLocationTextViewLink
                        testId={'edit'}
                        icon={<EditIcon />}
                        label={commonTranslationKeys.edit}
                        size={LinkSize.NORMAL}
                        onClick={onBlur}
                        block={false}
                     />
                  ) : null}
               </StyledFlex>
            </TextView>
         )}
      </FormController>
   );
};
